import type { PropsWithChildren, FunctionComponent } from 'react'
import {
  LocaleSelect,
  type LocaleSelectProps,
  type OnLocaleChangeCallback,
} from '@retailer-platform/shared-components'
import { useWarehouseContext } from '../../../utils/contexts/warehouse/WarehouseContext.hooks'

export const RetailerLocaleSelect: FunctionComponent<
  PropsWithChildren<Omit<LocaleSelectProps, 'locales'>>
> = props => {
  const { warehouse } = useWarehouseContext()

  return <LocaleSelect locales={warehouse.locales} {...props} />
}

export type { OnLocaleChangeCallback }
